// Returns true if given a function.

export default function isFunction(obj) {
  return typeof obj === 'function'
}



// WEBPACK FOOTER //
// ./src/isFunction.js